<div class="py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
            @for(item of componentModel.stats.value; track $index){
                <div class="mx-auto flex flex-col-reverse  max-w-xs gap-y-4"
                [ngClass]="{
                'flex-col-reverse' : item.image.value,
                'flex-col' : !item.image.value,
                }">
                    <dd class="order-first text-3xl font-semibold tracking-tight text-normal sm:text-5xl">{{item.description.value}}</dd>
                    <dt class="text-base/7 text-normal">{{item.title.value}}</dt>
                    @if(item.image.value){
                        <img loading="lazy"  [src]="item?.image?.value" class="max-w-32 rounded-2xl object-cover" [alt]="item.title.value">
                    }
                </div>
            }
        </dl>
    </div>
</div>

